import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-tabs-form',
  standalone: true,
  imports: [ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,

    CommonModule],
  templateUrl: './tabs-form.component.html',
  styleUrl: './tabs-form.component.css'
})
export class TabsFormComponent {

  @Output() changeForm = new EventEmitter<any>();

  @Input() updatesTabs: any = [];

  @Input() activeForm = 'general';
  @Input() role = 'Admin';
  @Input() draft = false;
  @Input() document_buttons_chico = false;
  @Input() account_type = 'broker';
  @Input() showBrokerExcludeTab: boolean = true;

  oldForm = 'general';

  emitchangeForm($event: any): void {
    this.oldForm = this.activeForm;
    this.changeForm.emit($event);
  }

  hideTab(tab: string): boolean {
    switch (tab) {
      case 'timeline':
        return !this.draft;
      case 'broker_exclude':
        return !this.showBrokerExcludeTab;
      default:
        return false;
    }
}

}
